export enum FabricationMethod {
  None = 0,
  selfPrint = 1,
  printAndShip = 2,
}
